module.exports = __webpack_public_path__ + "img/暂无收藏.66026192.png";